import { openModal } from '@core/components/ModalStack';
import { AssistantModalProps } from './AssistantModal';
import { R } from '@core/utils/r';

export async function openAssistantModal(props: AssistantModalProps) {
  const { AssistantModal } = await import('./AssistantModal');

  openModal(AssistantModal, props, { id: R.uniqueId(), name: 'AssistantModal' });
}
